import axios from 'helpers/axios';

export const getAdminPendingCounts = async () => {
    const { data } = await axios.get('/api/adminapi/pendingcounts/');
    return data;
};

export const getPayoutRequests = async ({ queryKey }) => {
    const [, selectType, page, pageSize] = queryKey;
    const { data } = await axios.get('/api/adminapi/payoutrequests/', {
        params: {
            processed: selectType === 'processed',
            limit: pageSize,
            offset: page * pageSize,
        }
    });

    return data;
};

export const getPayoutRequestDetail = async ({ queryKey }) => {
    const [, id] = queryKey;
    const { data } = await axios.get(`/api/adminapi/payoutrequests/${id}/`);

    return data;
};

export const confirmPayoutRequest = async (id: string) => {
    const { data } = await axios.post(`/api/adminapi/payoutrequests/${id}/confirm/`);

    return data;
};

export const deletePayoutRequest = async (id: string) => {
    const { data } = await axios.delete(`/api/adminapi/payoutrequests/${id}/`);

    return data;
};
